export const STORE_COMPANY = 'STORE_COMPANY';
export const STORE_COMPANY_MESSAGE = 'STORE_COMPANY_MESSAGE';

export const FETCH_COMPANIES = 'FETCH_COMPANIES';
export const FETCH_COMPANIES_OK = 'FETCH_COMPANIES_OK';
export const FETCH_COMPANIES_FAILED = 'FETCH_COMPANIES_FAILED';

export const RESET_COMPANY = 'RESET_COMPANY';
export const UPDATE_COMPANY = 'UPDATE_COMPANY';
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS';
export const UPDATE_COMPANY_ERROR = 'UPDATE_COMPANY_ERROR';

export const FETCH_COMPANY = 'FETCH_COMPANY';
export const FETCH_COMPANY_SUCCESS = 'FETCH_COMPANY_SUCCESS';
export const FETCH_COMPANY_ERROR = 'FETCH_COMPANY_ERROR';

